/**
 * 世界时区数据
 * 包含主要城市和时区信息
 */


// 扩展的全球主要时区数据
window.TIMEZONE_DATA = [
  // 亚洲时区 - 东亚
  { city: 'Beijing', country: 'China', timezone: 'Asia/Shanghai', code: 'CST', offset: '+8:00', searchTerms: ['beijing', 'china', 'cst', 'shanghai'] },
  { city: 'Shanghai', country: 'China', timezone: 'Asia/Shanghai', code: 'CST', offset: '+8:00', searchTerms: ['shanghai', 'china', 'cst'] },
  { city: 'Guangzhou', country: 'China', timezone: 'Asia/Shanghai', code: 'CST', offset: '+8:00', searchTerms: ['guangzhou', 'china', 'cst', 'canton'] },
  { city: 'Shenzhen', country: 'China', timezone: 'Asia/Shanghai', code: 'CST', offset: '+8:00', searchTerms: ['shenzhen', 'china', 'cst'] },
  { city: 'Tokyo', country: 'Japan', timezone: 'Asia/Tokyo', code: 'JST', offset: '+9:00', searchTerms: ['tokyo', 'japan', 'jst'] },
  { city: 'Osaka', country: 'Japan', timezone: 'Asia/Tokyo', code: 'JST', offset: '+9:00', searchTerms: ['osaka', 'japan', 'jst'] },
  { city: 'Seoul', country: 'South Korea', timezone: 'Asia/Seoul', code: 'KST', offset: '+9:00', searchTerms: ['seoul', 'korea', 'kst'] },
  { city: 'Busan', country: 'South Korea', timezone: 'Asia/Seoul', code: 'KST', offset: '+9:00', searchTerms: ['busan', 'korea', 'kst', 'pusan'] },
  { city: 'Hong Kong', country: 'Hong Kong', timezone: 'Asia/Hong_Kong', code: 'HKT', offset: '+8:00', searchTerms: ['hong kong', 'hkt'] },
  { city: 'Macau', country: 'Macau', timezone: 'Asia/Macau', code: 'CST', offset: '+8:00', searchTerms: ['macau', 'macao', 'cst'] },
  { city: 'Taipei', country: 'Taiwan', timezone: 'Asia/Taipei', code: 'CST', offset: '+8:00', searchTerms: ['taipei', 'taiwan', 'cst'] },

  // 亚洲时区 - 东南亚
  { city: 'Singapore', country: 'Singapore', timezone: 'Asia/Singapore', code: 'SGT', offset: '+8:00', searchTerms: ['singapore', 'sgt'] },
  { city: 'Bangkok', country: 'Thailand', timezone: 'Asia/Bangkok', code: 'ICT', offset: '+7:00', searchTerms: ['bangkok', 'thailand', 'ict'] },
  { city: 'Ho Chi Minh City', country: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh', code: 'ICT', offset: '+7:00', searchTerms: ['ho chi minh city', 'vietnam', 'ict', 'saigon'] },
  { city: 'Hanoi', country: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh', code: 'ICT', offset: '+7:00', searchTerms: ['hanoi', 'vietnam', 'ict'] },
  { city: 'Jakarta', country: 'Indonesia', timezone: 'Asia/Jakarta', code: 'WIB', offset: '+7:00', searchTerms: ['jakarta', 'indonesia', 'wib'] },
  { city: 'Bali', country: 'Indonesia', timezone: 'Asia/Makassar', code: 'WITA', offset: '+8:00', searchTerms: ['bali', 'indonesia', 'wita', 'denpasar'] },
  { city: 'Manila', country: 'Philippines', timezone: 'Asia/Manila', code: 'PHT', offset: '+8:00', searchTerms: ['manila', 'philippines', 'pht'] },
  { city: 'Kuala Lumpur', country: 'Malaysia', timezone: 'Asia/Kuala_Lumpur', code: 'MYT', offset: '+8:00', searchTerms: ['kuala lumpur', 'malaysia', 'myt'] },
  { city: 'Yangon', country: 'Myanmar', timezone: 'Asia/Yangon', code: 'MMT', offset: '+6:30', searchTerms: ['yangon', 'myanmar', 'mmt', 'rangoon'] },
  { city: 'Phnom Penh', country: 'Cambodia', timezone: 'Asia/Phnom_Penh', code: 'ICT', offset: '+7:00', searchTerms: ['phnom penh', 'cambodia', 'ict'] },

  // 亚洲时区 - 南亚
  { city: 'Mumbai', country: 'India', timezone: 'Asia/Kolkata', code: 'IST', offset: '+5:30', searchTerms: ['mumbai', 'india', 'ist', 'bombay'] },
  { city: 'Delhi', country: 'India', timezone: 'Asia/Kolkata', code: 'IST', offset: '+5:30', searchTerms: ['delhi', 'india', 'ist', 'new delhi'] },
  { city: 'Bangalore', country: 'India', timezone: 'Asia/Kolkata', code: 'IST', offset: '+5:30', searchTerms: ['bangalore', 'india', 'ist', 'bengaluru'] },
  { city: 'Chennai', country: 'India', timezone: 'Asia/Kolkata', code: 'IST', offset: '+5:30', searchTerms: ['chennai', 'india', 'ist', 'madras'] },
  { city: 'Kolkata', country: 'India', timezone: 'Asia/Kolkata', code: 'IST', offset: '+5:30', searchTerms: ['kolkata', 'india', 'ist', 'calcutta'] },
  { city: 'Dhaka', country: 'Bangladesh', timezone: 'Asia/Dhaka', code: 'BST', offset: '+6:00', searchTerms: ['dhaka', 'bangladesh', 'bst'] },
  { city: 'Karachi', country: 'Pakistan', timezone: 'Asia/Karachi', code: 'PKT', offset: '+5:00', searchTerms: ['karachi', 'pakistan', 'pkt'] },
  { city: 'Lahore', country: 'Pakistan', timezone: 'Asia/Karachi', code: 'PKT', offset: '+5:00', searchTerms: ['lahore', 'pakistan', 'pkt'] },
  { city: 'Islamabad', country: 'Pakistan', timezone: 'Asia/Karachi', code: 'PKT', offset: '+5:00', searchTerms: ['islamabad', 'pakistan', 'pkt'] },
  { city: 'Kathmandu', country: 'Nepal', timezone: 'Asia/Kathmandu', code: 'NPT', offset: '+5:45', searchTerms: ['kathmandu', 'nepal', 'npt'] },
  { city: 'Colombo', country: 'Sri Lanka', timezone: 'Asia/Colombo', code: 'IST', offset: '+5:30', searchTerms: ['colombo', 'sri lanka', 'ist'] },

  // 亚洲时区 - 中亚和西亚
  { city: 'Dubai', country: 'UAE', timezone: 'Asia/Dubai', code: 'GST', offset: '+4:00', searchTerms: ['dubai', 'uae', 'gst'] },
  { city: 'Abu Dhabi', country: 'UAE', timezone: 'Asia/Dubai', code: 'GST', offset: '+4:00', searchTerms: ['abu dhabi', 'uae', 'gst'] },
  { city: 'Doha', country: 'Qatar', timezone: 'Asia/Qatar', code: 'AST', offset: '+3:00', searchTerms: ['doha', 'qatar', 'ast'] },
  { city: 'Kuwait City', country: 'Kuwait', timezone: 'Asia/Kuwait', code: 'AST', offset: '+3:00', searchTerms: ['kuwait city', 'kuwait', 'ast'] },
  { city: 'Riyadh', country: 'Saudi Arabia', timezone: 'Asia/Riyadh', code: 'AST', offset: '+3:00', searchTerms: ['riyadh', 'saudi arabia', 'ast'] },
  { city: 'Tehran', country: 'Iran', timezone: 'Asia/Tehran', code: 'IRST', offset: '+3:30', searchTerms: ['tehran', 'iran', 'irst'] },
  { city: 'Baghdad', country: 'Iraq', timezone: 'Asia/Baghdad', code: 'AST', offset: '+3:00', searchTerms: ['baghdad', 'iraq', 'ast'] },
  { city: 'Tashkent', country: 'Uzbekistan', timezone: 'Asia/Tashkent', code: 'UZT', offset: '+5:00', searchTerms: ['tashkent', 'uzbekistan', 'uzt'] },
  { city: 'Almaty', country: 'Kazakhstan', timezone: 'Asia/Almaty', code: 'ALMT', offset: '+6:00', searchTerms: ['almaty', 'kazakhstan', 'almt'] },

  // 欧洲时区 - 西欧
  { city: 'London', country: 'United Kingdom', timezone: 'Europe/London', code: 'GMT', offset: '+0:00', searchTerms: ['london', 'uk', 'gmt', 'bst'] },
  { city: 'Edinburgh', country: 'United Kingdom', timezone: 'Europe/London', code: 'GMT', offset: '+0:00', searchTerms: ['edinburgh', 'scotland', 'uk', 'gmt', 'bst'] },
  { city: 'Dublin', country: 'Ireland', timezone: 'Europe/Dublin', code: 'GMT', offset: '+0:00', searchTerms: ['dublin', 'ireland', 'gmt', 'ist'] },
  { city: 'Lisbon', country: 'Portugal', timezone: 'Europe/Lisbon', code: 'WET', offset: '+0:00', searchTerms: ['lisbon', 'portugal', 'wet', 'west'] },

  // 欧洲时区 - 中欧
  { city: 'Paris', country: 'France', timezone: 'Europe/Paris', code: 'CET', offset: '+1:00', searchTerms: ['paris', 'france', 'cet', 'cest'] },
  { city: 'Lyon', country: 'France', timezone: 'Europe/Paris', code: 'CET', offset: '+1:00', searchTerms: ['lyon', 'france', 'cet', 'cest'] },
  { city: 'Berlin', country: 'Germany', timezone: 'Europe/Berlin', code: 'CET', offset: '+1:00', searchTerms: ['berlin', 'germany', 'cet', 'cest'] },
  { city: 'Munich', country: 'Germany', timezone: 'Europe/Berlin', code: 'CET', offset: '+1:00', searchTerms: ['munich', 'germany', 'cet', 'cest', 'münchen'] },
  { city: 'Frankfurt', country: 'Germany', timezone: 'Europe/Berlin', code: 'CET', offset: '+1:00', searchTerms: ['frankfurt', 'germany', 'cet', 'cest'] },
  { city: 'Rome', country: 'Italy', timezone: 'Europe/Rome', code: 'CET', offset: '+1:00', searchTerms: ['rome', 'italy', 'cet', 'cest'] },
  { city: 'Milan', country: 'Italy', timezone: 'Europe/Rome', code: 'CET', offset: '+1:00', searchTerms: ['milan', 'italy', 'cet', 'cest'] },
  { city: 'Madrid', country: 'Spain', timezone: 'Europe/Madrid', code: 'CET', offset: '+1:00', searchTerms: ['madrid', 'spain', 'cet', 'cest'] },
  { city: 'Barcelona', country: 'Spain', timezone: 'Europe/Madrid', code: 'CET', offset: '+1:00', searchTerms: ['barcelona', 'spain', 'cet', 'cest'] },
  { city: 'Amsterdam', country: 'Netherlands', timezone: 'Europe/Amsterdam', code: 'CET', offset: '+1:00', searchTerms: ['amsterdam', 'netherlands', 'cet', 'cest'] },
  { city: 'Brussels', country: 'Belgium', timezone: 'Europe/Brussels', code: 'CET', offset: '+1:00', searchTerms: ['brussels', 'belgium', 'cet', 'cest'] },
  { city: 'Vienna', country: 'Austria', timezone: 'Europe/Vienna', code: 'CET', offset: '+1:00', searchTerms: ['vienna', 'austria', 'cet', 'cest'] },
  { city: 'Zurich', country: 'Switzerland', timezone: 'Europe/Zurich', code: 'CET', offset: '+1:00', searchTerms: ['zurich', 'switzerland', 'cet', 'cest'] },
  { city: 'Prague', country: 'Czech Republic', timezone: 'Europe/Prague', code: 'CET', offset: '+1:00', searchTerms: ['prague', 'czech republic', 'cet', 'cest'] },
  { city: 'Warsaw', country: 'Poland', timezone: 'Europe/Warsaw', code: 'CET', offset: '+1:00', searchTerms: ['warsaw', 'poland', 'cet', 'cest'] },
  { city: 'Budapest', country: 'Hungary', timezone: 'Europe/Budapest', code: 'CET', offset: '+1:00', searchTerms: ['budapest', 'hungary', 'cet', 'cest'] },

  // 欧洲时区 - 东欧
  { city: 'Moscow', country: 'Russia', timezone: 'Europe/Moscow', code: 'MSK', offset: '+3:00', searchTerms: ['moscow', 'russia', 'msk'] },
  { city: 'St. Petersburg', country: 'Russia', timezone: 'Europe/Moscow', code: 'MSK', offset: '+3:00', searchTerms: ['st petersburg', 'russia', 'msk', 'saint petersburg'] },
  { city: 'Istanbul', country: 'Turkey', timezone: 'Europe/Istanbul', code: 'TRT', offset: '+3:00', searchTerms: ['istanbul', 'turkey', 'trt'] },
  { city: 'Ankara', country: 'Turkey', timezone: 'Europe/Istanbul', code: 'TRT', offset: '+3:00', searchTerms: ['ankara', 'turkey', 'trt'] },
  { city: 'Kiev', country: 'Ukraine', timezone: 'Europe/Kiev', code: 'EET', offset: '+2:00', searchTerms: ['kiev', 'ukraine', 'eet', 'eest', 'kyiv'] },
  { city: 'Bucharest', country: 'Romania', timezone: 'Europe/Bucharest', code: 'EET', offset: '+2:00', searchTerms: ['bucharest', 'romania', 'eet', 'eest'] },
  { city: 'Athens', country: 'Greece', timezone: 'Europe/Athens', code: 'EET', offset: '+2:00', searchTerms: ['athens', 'greece', 'eet', 'eest'] },
  { city: 'Sofia', country: 'Bulgaria', timezone: 'Europe/Sofia', code: 'EET', offset: '+2:00', searchTerms: ['sofia', 'bulgaria', 'eet', 'eest'] },

  // 欧洲时区 - 北欧
  { city: 'Stockholm', country: 'Sweden', timezone: 'Europe/Stockholm', code: 'CET', offset: '+1:00', searchTerms: ['stockholm', 'sweden', 'cet', 'cest'] },
  { city: 'Oslo', country: 'Norway', timezone: 'Europe/Oslo', code: 'CET', offset: '+1:00', searchTerms: ['oslo', 'norway', 'cet', 'cest'] },
  { city: 'Copenhagen', country: 'Denmark', timezone: 'Europe/Copenhagen', code: 'CET', offset: '+1:00', searchTerms: ['copenhagen', 'denmark', 'cet', 'cest'] },
  { city: 'Helsinki', country: 'Finland', timezone: 'Europe/Helsinki', code: 'EET', offset: '+2:00', searchTerms: ['helsinki', 'finland', 'eet', 'eest'] },

  // 北美时区 - 美国
  { city: 'New York', country: 'United States', timezone: 'America/New_York', code: 'EST', offset: '-5:00', searchTerms: ['new york', 'nyc', 'usa', 'est', 'edt'] },
  { city: 'Washington DC', country: 'United States', timezone: 'America/New_York', code: 'EST', offset: '-5:00', searchTerms: ['washington dc', 'usa', 'est', 'edt'] },
  { city: 'Boston', country: 'United States', timezone: 'America/New_York', code: 'EST', offset: '-5:00', searchTerms: ['boston', 'usa', 'est', 'edt'] },
  { city: 'Miami', country: 'United States', timezone: 'America/New_York', code: 'EST', offset: '-5:00', searchTerms: ['miami', 'usa', 'est', 'edt'] },
  { city: 'Atlanta', country: 'United States', timezone: 'America/New_York', code: 'EST', offset: '-5:00', searchTerms: ['atlanta', 'usa', 'est', 'edt'] },
  { city: 'Chicago', country: 'United States', timezone: 'America/Chicago', code: 'CST', offset: '-6:00', searchTerms: ['chicago', 'usa', 'cst', 'cdt'] },
  { city: 'Dallas', country: 'United States', timezone: 'America/Chicago', code: 'CST', offset: '-6:00', searchTerms: ['dallas', 'usa', 'cst', 'cdt'] },
  { city: 'Houston', country: 'United States', timezone: 'America/Chicago', code: 'CST', offset: '-6:00', searchTerms: ['houston', 'usa', 'cst', 'cdt'] },
  { city: 'New Orleans', country: 'United States', timezone: 'America/Chicago', code: 'CST', offset: '-6:00', searchTerms: ['new orleans', 'usa', 'cst', 'cdt'] },
  { city: 'Denver', country: 'United States', timezone: 'America/Denver', code: 'MST', offset: '-7:00', searchTerms: ['denver', 'usa', 'mst', 'mdt'] },
  { city: 'Phoenix', country: 'United States', timezone: 'America/Phoenix', code: 'MST', offset: '-7:00', searchTerms: ['phoenix', 'usa', 'mst'] },
  { city: 'Salt Lake City', country: 'United States', timezone: 'America/Denver', code: 'MST', offset: '-7:00', searchTerms: ['salt lake city', 'usa', 'mst', 'mdt'] },
  { city: 'Los Angeles', country: 'United States', timezone: 'America/Los_Angeles', code: 'PST', offset: '-8:00', searchTerms: ['los angeles', 'la', 'usa', 'pst', 'pdt'] },
  { city: 'San Francisco', country: 'United States', timezone: 'America/Los_Angeles', code: 'PST', offset: '-8:00', searchTerms: ['san francisco', 'usa', 'pst', 'pdt'] },
  { city: 'Seattle', country: 'United States', timezone: 'America/Los_Angeles', code: 'PST', offset: '-8:00', searchTerms: ['seattle', 'usa', 'pst', 'pdt'] },
  { city: 'Las Vegas', country: 'United States', timezone: 'America/Los_Angeles', code: 'PST', offset: '-8:00', searchTerms: ['las vegas', 'usa', 'pst', 'pdt'] },
  { city: 'Anchorage', country: 'United States', timezone: 'America/Anchorage', code: 'AKST', offset: '-9:00', searchTerms: ['anchorage', 'alaska', 'usa', 'akst', 'akdt'] },
  { city: 'Honolulu', country: 'United States', timezone: 'Pacific/Honolulu', code: 'HST', offset: '-10:00', searchTerms: ['honolulu', 'hawaii', 'usa', 'hst'] },

  // 北美时区 - 加拿大
  { city: 'Toronto', country: 'Canada', timezone: 'America/Toronto', code: 'EST', offset: '-5:00', searchTerms: ['toronto', 'canada', 'est', 'edt'] },
  { city: 'Montreal', country: 'Canada', timezone: 'America/Montreal', code: 'EST', offset: '-5:00', searchTerms: ['montreal', 'canada', 'est', 'edt'] },
  { city: 'Ottawa', country: 'Canada', timezone: 'America/Toronto', code: 'EST', offset: '-5:00', searchTerms: ['ottawa', 'canada', 'est', 'edt'] },
  { city: 'Vancouver', country: 'Canada', timezone: 'America/Vancouver', code: 'PST', offset: '-8:00', searchTerms: ['vancouver', 'canada', 'pst', 'pdt'] },
  { city: 'Calgary', country: 'Canada', timezone: 'America/Edmonton', code: 'MST', offset: '-7:00', searchTerms: ['calgary', 'canada', 'mst', 'mdt'] },
  { city: 'Edmonton', country: 'Canada', timezone: 'America/Edmonton', code: 'MST', offset: '-7:00', searchTerms: ['edmonton', 'canada', 'mst', 'mdt'] },
  { city: 'Winnipeg', country: 'Canada', timezone: 'America/Winnipeg', code: 'CST', offset: '-6:00', searchTerms: ['winnipeg', 'canada', 'cst', 'cdt'] },

  // 北美时区 - 墨西哥
  { city: 'Mexico City', country: 'Mexico', timezone: 'America/Mexico_City', code: 'CST', offset: '-6:00', searchTerms: ['mexico city', 'mexico', 'cst', 'cdt'] },
  { city: 'Guadalajara', country: 'Mexico', timezone: 'America/Mexico_City', code: 'CST', offset: '-6:00', searchTerms: ['guadalajara', 'mexico', 'cst', 'cdt'] },
  { city: 'Tijuana', country: 'Mexico', timezone: 'America/Tijuana', code: 'PST', offset: '-8:00', searchTerms: ['tijuana', 'mexico', 'pst', 'pdt'] },

  // 南美时区
  { city: 'São Paulo', country: 'Brazil', timezone: 'America/Sao_Paulo', code: 'BRT', offset: '-3:00', searchTerms: ['sao paulo', 'brazil', 'brt', 'brst'] },
  { city: 'Rio de Janeiro', country: 'Brazil', timezone: 'America/Sao_Paulo', code: 'BRT', offset: '-3:00', searchTerms: ['rio de janeiro', 'brazil', 'brt', 'brst'] },
  { city: 'Brasilia', country: 'Brazil', timezone: 'America/Sao_Paulo', code: 'BRT', offset: '-3:00', searchTerms: ['brasilia', 'brazil', 'brt', 'brst'] },
  { city: 'Buenos Aires', country: 'Argentina', timezone: 'America/Argentina/Buenos_Aires', code: 'ART', offset: '-3:00', searchTerms: ['buenos aires', 'argentina', 'art'] },
  { city: 'Córdoba', country: 'Argentina', timezone: 'America/Argentina/Cordoba', code: 'ART', offset: '-3:00', searchTerms: ['cordoba', 'argentina', 'art'] },
  { city: 'Santiago', country: 'Chile', timezone: 'America/Santiago', code: 'CLT', offset: '-4:00', searchTerms: ['santiago', 'chile', 'clt', 'clst'] },
  { city: 'Lima', country: 'Peru', timezone: 'America/Lima', code: 'PET', offset: '-5:00', searchTerms: ['lima', 'peru', 'pet'] },
  { city: 'Bogotá', country: 'Colombia', timezone: 'America/Bogota', code: 'COT', offset: '-5:00', searchTerms: ['bogota', 'colombia', 'cot'] },
  { city: 'Caracas', country: 'Venezuela', timezone: 'America/Caracas', code: 'VET', offset: '-4:00', searchTerms: ['caracas', 'venezuela', 'vet'] },
  { city: 'Quito', country: 'Ecuador', timezone: 'America/Guayaquil', code: 'ECT', offset: '-5:00', searchTerms: ['quito', 'ecuador', 'ect'] },
  { city: 'La Paz', country: 'Bolivia', timezone: 'America/La_Paz', code: 'BOT', offset: '-4:00', searchTerms: ['la paz', 'bolivia', 'bot'] },
  { city: 'Montevideo', country: 'Uruguay', timezone: 'America/Montevideo', code: 'UYT', offset: '-3:00', searchTerms: ['montevideo', 'uruguay', 'uyt'] },

  // 大洋洲时区 - 澳大利亚
  { city: 'Sydney', country: 'Australia', timezone: 'Australia/Sydney', code: 'AEST', offset: '+10:00', searchTerms: ['sydney', 'australia', 'aest', 'aedt'] },
  { city: 'Melbourne', country: 'Australia', timezone: 'Australia/Melbourne', code: 'AEST', offset: '+10:00', searchTerms: ['melbourne', 'australia', 'aest', 'aedt'] },
  { city: 'Brisbane', country: 'Australia', timezone: 'Australia/Brisbane', code: 'AEST', offset: '+10:00', searchTerms: ['brisbane', 'australia', 'aest'] },
  { city: 'Perth', country: 'Australia', timezone: 'Australia/Perth', code: 'AWST', offset: '+8:00', searchTerms: ['perth', 'australia', 'awst'] },
  { city: 'Adelaide', country: 'Australia', timezone: 'Australia/Adelaide', code: 'ACST', offset: '+9:30', searchTerms: ['adelaide', 'australia', 'acst', 'acdt'] },
  { city: 'Darwin', country: 'Australia', timezone: 'Australia/Darwin', code: 'ACST', offset: '+9:30', searchTerms: ['darwin', 'australia', 'acst'] },
  { city: 'Hobart', country: 'Australia', timezone: 'Australia/Hobart', code: 'AEST', offset: '+10:00', searchTerms: ['hobart', 'australia', 'aest', 'aedt'] },

  // 大洋洲时区 - 新西兰和太平洋岛屿
  { city: 'Auckland', country: 'New Zealand', timezone: 'Pacific/Auckland', code: 'NZST', offset: '+12:00', searchTerms: ['auckland', 'new zealand', 'nzst', 'nzdt'] },
  { city: 'Wellington', country: 'New Zealand', timezone: 'Pacific/Auckland', code: 'NZST', offset: '+12:00', searchTerms: ['wellington', 'new zealand', 'nzst', 'nzdt'] },
  { city: 'Christchurch', country: 'New Zealand', timezone: 'Pacific/Auckland', code: 'NZST', offset: '+12:00', searchTerms: ['christchurch', 'new zealand', 'nzst', 'nzdt'] },
  { city: 'Suva', country: 'Fiji', timezone: 'Pacific/Fiji', code: 'FJT', offset: '+12:00', searchTerms: ['suva', 'fiji', 'fjt'] },
  { city: 'Port Moresby', country: 'Papua New Guinea', timezone: 'Pacific/Port_Moresby', code: 'PGT', offset: '+10:00', searchTerms: ['port moresby', 'papua new guinea', 'pgt'] },

  // 非洲时区 - 北非
  { city: 'Cairo', country: 'Egypt', timezone: 'Africa/Cairo', code: 'EET', offset: '+2:00', searchTerms: ['cairo', 'egypt', 'eet', 'eest'] },
  { city: 'Alexandria', country: 'Egypt', timezone: 'Africa/Cairo', code: 'EET', offset: '+2:00', searchTerms: ['alexandria', 'egypt', 'eet', 'eest'] },
  { city: 'Casablanca', country: 'Morocco', timezone: 'Africa/Casablanca', code: 'WET', offset: '+0:00', searchTerms: ['casablanca', 'morocco', 'wet', 'west'] },
  { city: 'Rabat', country: 'Morocco', timezone: 'Africa/Casablanca', code: 'WET', offset: '+0:00', searchTerms: ['rabat', 'morocco', 'wet', 'west'] },
  { city: 'Algiers', country: 'Algeria', timezone: 'Africa/Algiers', code: 'CET', offset: '+1:00', searchTerms: ['algiers', 'algeria', 'cet'] },
  { city: 'Tunis', country: 'Tunisia', timezone: 'Africa/Tunis', code: 'CET', offset: '+1:00', searchTerms: ['tunis', 'tunisia', 'cet'] },
  { city: 'Tripoli', country: 'Libya', timezone: 'Africa/Tripoli', code: 'EET', offset: '+2:00', searchTerms: ['tripoli', 'libya', 'eet'] },

  // 非洲时区 - 西非
  { city: 'Lagos', country: 'Nigeria', timezone: 'Africa/Lagos', code: 'WAT', offset: '+1:00', searchTerms: ['lagos', 'nigeria', 'wat'] },
  { city: 'Abuja', country: 'Nigeria', timezone: 'Africa/Lagos', code: 'WAT', offset: '+1:00', searchTerms: ['abuja', 'nigeria', 'wat'] },
  { city: 'Accra', country: 'Ghana', timezone: 'Africa/Accra', code: 'GMT', offset: '+0:00', searchTerms: ['accra', 'ghana', 'gmt'] },
  { city: 'Dakar', country: 'Senegal', timezone: 'Africa/Dakar', code: 'GMT', offset: '+0:00', searchTerms: ['dakar', 'senegal', 'gmt'] },
  { city: 'Abidjan', country: 'Ivory Coast', timezone: 'Africa/Abidjan', code: 'GMT', offset: '+0:00', searchTerms: ['abidjan', 'ivory coast', 'gmt'] },

  // 非洲时区 - 东非
  { city: 'Nairobi', country: 'Kenya', timezone: 'Africa/Nairobi', code: 'EAT', offset: '+3:00', searchTerms: ['nairobi', 'kenya', 'eat'] },
  { city: 'Addis Ababa', country: 'Ethiopia', timezone: 'Africa/Addis_Ababa', code: 'EAT', offset: '+3:00', searchTerms: ['addis ababa', 'ethiopia', 'eat'] },
  { city: 'Dar es Salaam', country: 'Tanzania', timezone: 'Africa/Dar_es_Salaam', code: 'EAT', offset: '+3:00', searchTerms: ['dar es salaam', 'tanzania', 'eat'] },
  { city: 'Kampala', country: 'Uganda', timezone: 'Africa/Kampala', code: 'EAT', offset: '+3:00', searchTerms: ['kampala', 'uganda', 'eat'] },

  // 非洲时区 - 南非
  { city: 'Cape Town', country: 'South Africa', timezone: 'Africa/Johannesburg', code: 'SAST', offset: '+2:00', searchTerms: ['cape town', 'south africa', 'sast'] },
  { city: 'Johannesburg', country: 'South Africa', timezone: 'Africa/Johannesburg', code: 'SAST', offset: '+2:00', searchTerms: ['johannesburg', 'south africa', 'sast'] },
  { city: 'Durban', country: 'South Africa', timezone: 'Africa/Johannesburg', code: 'SAST', offset: '+2:00', searchTerms: ['durban', 'south africa', 'sast'] },
  { city: 'Pretoria', country: 'South Africa', timezone: 'Africa/Johannesburg', code: 'SAST', offset: '+2:00', searchTerms: ['pretoria', 'south africa', 'sast'] },

  // 其他重要时区
  { city: 'Reykjavik', country: 'Iceland', timezone: 'Atlantic/Reykjavik', code: 'GMT', offset: '+0:00', searchTerms: ['reykjavik', 'iceland', 'gmt'] },
  { city: 'Bermuda', country: 'Bermuda', timezone: 'Atlantic/Bermuda', code: 'AST', offset: '-4:00', searchTerms: ['bermuda', 'ast', 'adt'] },
  { city: 'Azores', country: 'Portugal', timezone: 'Atlantic/Azores', code: 'AZOT', offset: '-1:00', searchTerms: ['azores', 'portugal', 'azot', 'azost'] }
];

/**
 * 时区偏移解析
 * 将 "+8:00" 或 "-5:30" 转换为分钟数
 */
window.parseTimezoneOffset = function(offsetStr) {
  if (!offsetStr) return 0;
  
  const match = offsetStr.match(/([+-])(\d{1,2}):(\d{2})/);
  if (!match) return 0;
  
  const sign = match[1] === '+' ? 1 : -1;
  const hours = parseInt(match[2], 10);
  const minutes = parseInt(match[3], 10);
  
  return sign * (hours * 60 + minutes);
};

/**
 * 搜索时区数据
 */
window.searchTimezones = function(query) {
  if (!query || query.length < 1) return [];
  
  const normalizedQuery = query.toLowerCase().trim();
  
  return window.TIMEZONE_DATA.filter(tz => {
    // 搜索城市名
    if (tz.city.toLowerCase().includes(normalizedQuery)) return true;
    
    // 搜索国家名
    if (tz.country.toLowerCase().includes(normalizedQuery)) return true;
    
    // 搜索时区代码
    if (tz.code.toLowerCase().includes(normalizedQuery)) return true;
    
    // 搜索自定义搜索词
    return tz.searchTerms.some(term => term.includes(normalizedQuery));
  }).slice(0, 10); // 限制返回结果数量
};

/**
 * 动态夏令时检测系统
 * 使用浏览器原生 Intl API 检测实际的时区信息
 */
window.getDynamicTimezoneInfo = function(timezone) {
  if (!timezone) return null;
  
  try {
    const now = new Date();
    
    // 获取时区的实际偏移量（分钟）
    const formatter = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'longOffset'
    });
    
    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find(part => part.type === 'timeZoneName');
    
    if (offsetPart && offsetPart.value) {
      const offsetMatch = offsetPart.value.match(/GMT([+-])(\d{1,2}):?(\d{2})?/);
      if (offsetMatch) {
        const sign = offsetMatch[1] === '+' ? 1 : -1;
        const hours = parseInt(offsetMatch[2], 10);
        const minutes = parseInt(offsetMatch[3] || '0', 10);
        const totalMinutes = sign * (hours * 60 + minutes);
        
        // 格式化偏移量字符串
        const offsetStr = `${sign > 0 ? '+' : '-'}${Math.abs(hours)}:${Math.abs(minutes).toString().padStart(2, '0')}`;
        
        // 获取时区缩写代码
        const shortFormatter = new Intl.DateTimeFormat('en', {
          timeZone: timezone,
          timeZoneName: 'short'
        });
        
        const shortParts = shortFormatter.formatToParts(now);
        const codePart = shortParts.find(part => part.type === 'timeZoneName');
        const currentCode = codePart ? codePart.value : null;
        
        const isDst = isDaylightSavingTime(timezone, now);
        
        
        return {
          timezone: timezone,
          currentOffset: offsetStr,
          currentCode: currentCode,
          offsetMinutes: totalMinutes,
          isDST: isDst,
          timestamp: now.getTime()
        };
      }
    }
  } catch (error) {
    console.warn('🌍 Dynamic timezone detection failed for:', timezone, error);
  }
  
  return null;
};

/**
 * 检测指定时区是否处于夏令时
 * 改进版：基于静态偏移量和当前偏移量的对比
 */
function isDaylightSavingTime(timezone, date = new Date()) {
  try {
    // 获取1月份的偏移量（通常是标准时间）
    const january = new Date(date.getFullYear(), 0, 15);  // 1月15日，避免新年边界问题
    const januaryOffset = getTimezoneOffset(timezone, january);
    
    // 获取7月份的偏移量（通常是夏令时）
    const july = new Date(date.getFullYear(), 6, 15);      // 7月15日，夏令时期间
    const julyOffset = getTimezoneOffset(timezone, july);
    
    // 获取当前日期的偏移量
    const currentOffset = getTimezoneOffset(timezone, date);
    
    
    // 如果1月和7月的偏移量不同，说明该时区有DST
    if (Math.abs(januaryOffset - julyOffset) >= 60) { // 至少1小时的差异
      // 对于北半球：夏令时偏移量 > 标准时间偏移量
      // 对于南半球：夏令时偏移量 < 标准时间偏移量
      const maxOffset = Math.max(januaryOffset, julyOffset);
      const minOffset = Math.min(januaryOffset, julyOffset);
      
      // 判断是否处于DST期间
      const isDst = (currentOffset === maxOffset && maxOffset > minOffset) || 
                    (currentOffset === minOffset && minOffset < maxOffset && timezone.includes('Australia'));
      
      
      return isDst;
    }
    
    return false;
  } catch (error) {
    return false;
  }
}

/**
 * 获取特定时区在特定日期的UTC偏移量（分钟）
 */
function getTimezoneOffset(timezone, date) {
  try {
    const utc = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
    const local = new Date(utc.toLocaleString("en-US", {timeZone: timezone}));
    return (local.getTime() - utc.getTime()) / 60000;
  } catch (error) {
    return 0;
  }
}

// DST检测结果缓存
const dstCache = new Map();
const CACHE_DURATION = 60 * 60 * 1000; // 1小时缓存

/**
 * 获取增强的时区信息（包含动态DST数据，带缓存）
 */
window.getEnhancedTimezoneData = function(staticTimezoneData) {
  const enhanced = {...staticTimezoneData};
  const timezone = staticTimezoneData.timezone;
  const now = Date.now();
  
  // 检查缓存
  const cacheKey = `${timezone}_${Math.floor(now / CACHE_DURATION)}`;
  if (dstCache.has(cacheKey)) {
    const cached = dstCache.get(cacheKey);
    return {...enhanced, ...cached};
  }
  
  // 获取动态时区信息
  const dynamicInfo = window.getDynamicTimezoneInfo(timezone);
  
  let result;
  if (dynamicInfo) {
    // 使用动态检测到的时区代码和偏移量
    const displayCode = getDisplayCode(timezone, dynamicInfo.currentCode, dynamicInfo.isDST, dynamicInfo.currentOffset);
    
    result = {
      currentCode: dynamicInfo.currentCode || enhanced.code,
      currentOffset: dynamicInfo.currentOffset || enhanced.offset,
      isDST: dynamicInfo.isDST,
      displayCode: displayCode || dynamicInfo.currentCode || enhanced.code,
      displayOffset: dynamicInfo.currentOffset || enhanced.offset
    };
  } else {
    // 如果动态检测失败，使用静态数据
    result = {
      currentCode: enhanced.code,
      currentOffset: enhanced.offset,
      isDST: false,
      displayCode: enhanced.code,
      displayOffset: enhanced.offset
    };
  }
  
  // 缓存结果
  dstCache.set(cacheKey, result);
  
  // 清理旧缓存（保持缓存大小合理）
  if (dstCache.size > 200) {
    const oldKeys = Array.from(dstCache.keys()).slice(0, 50);
    oldKeys.forEach(key => dstCache.delete(key));
  }
  
  return {...enhanced, ...result};
};

/**
 * 获取更友好的显示代码
 * 基于偏移量和DST状态的智能判断
 */
function getDisplayCode(timezone, currentCode, isDST, currentOffset) {
  if (!currentCode) return null;
  
  // 解析当前偏移量
  const offsetMinutes = parseOffsetToMinutes(currentOffset);
  
  // 基于偏移量和时区的智能映射
  const timezoneMapping = {
    'Europe/London': {
      '+0:00': 'GMT',
      '+1:00': 'BST'
    },
    'Europe/Dublin': {
      '+0:00': 'GMT', 
      '+1:00': 'IST'
    },
    'America/New_York': {
      '-5:00': 'EST',
      '-4:00': 'EDT'
    },
    'America/Los_Angeles': {
      '-8:00': 'PST',
      '-7:00': 'PDT'
    },
    'America/Chicago': {
      '-6:00': 'CST',
      '-5:00': 'CDT'
    },
    'America/Denver': {
      '-7:00': 'MST',
      '-6:00': 'MDT'
    },
    'America/Toronto': {
      '-5:00': 'EST',
      '-4:00': 'EDT'
    },
    'America/Vancouver': {
      '-8:00': 'PST',
      '-7:00': 'PDT'
    },
    'Europe/Paris': {
      '+1:00': 'CET',
      '+2:00': 'CEST'
    },
    'Europe/Berlin': {
      '+1:00': 'CET',
      '+2:00': 'CEST'
    },
    'Europe/Rome': {
      '+1:00': 'CET',
      '+2:00': 'CEST'
    },
    'Europe/Madrid': {
      '+1:00': 'CET',
      '+2:00': 'CEST'
    },
    'Europe/Amsterdam': {
      '+1:00': 'CET',
      '+2:00': 'CEST'
    },
    'Australia/Sydney': {
      '+10:00': 'AEST',
      '+11:00': 'AEDT'
    },
    'Australia/Melbourne': {
      '+10:00': 'AEST',
      '+11:00': 'AEDT'
    },
    'Pacific/Auckland': {
      '+12:00': 'NZST',
      '+13:00': 'NZDT'
    }
  };
  
  // 优先使用基于偏移量的映射
  if (timezoneMapping[timezone] && timezoneMapping[timezone][currentOffset]) {
    const mappedCode = timezoneMapping[timezone][currentOffset];
    
    
    return mappedCode;
  }
  
  // 如果没有精确匹配，使用原始代码但清理格式
  if (currentCode.startsWith('GMT')) {
    return currentCode.replace('GMT', '').replace('+', '') || 'GMT';
  }
  
  return currentCode;
}

/**
 * 将偏移量字符串转换为分钟数
 */
function parseOffsetToMinutes(offsetStr) {
  if (!offsetStr) return 0;
  const match = offsetStr.match(/([+-])(\d{1,2}):(\d{2})/);
  if (!match) return 0;
  
  const sign = match[1] === '+' ? 1 : -1;
  const hours = parseInt(match[2], 10);
  const minutes = parseInt(match[3], 10);
  
  return sign * (hours * 60 + minutes);
}

/**
 * 批量获取增强的时区数据
 */
window.getAllEnhancedTimezones = function() {
  return window.TIMEZONE_DATA.map(tz => window.getEnhancedTimezoneData(tz));
};

/**
 * 搜索函数 - 使用静态数据确保快速响应
 */
window.searchTimezones = function(query) {
  if (!query || query.length < 1) return [];
  
  const normalizedQuery = query.toLowerCase().trim();
  
  return window.TIMEZONE_DATA.filter(tz => {
    // 搜索城市名
    if (tz.city.toLowerCase().includes(normalizedQuery)) return true;
    
    // 搜索国家名
    if (tz.country.toLowerCase().includes(normalizedQuery)) return true;
    
    // 搜索时区代码
    if (tz.code.toLowerCase().includes(normalizedQuery)) return true;
    
    // 搜索自定义搜索词
    return tz.searchTerms.some(term => term.includes(normalizedQuery));
  }).slice(0, 10); // 限制返回结果数量
};

